import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import Copyright from "../../internals/components/Copyright";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { useNavigate } from "react-router";

const ReportsMain = () => {
	const navigate = useNavigate();

	const openCustomerDeposits = (e) => {
		e.preventDefault();
		navigate("/reports/customerdeposits");
	};

	const openCustomerWithdrawals = (e) => {
		e.preventDefault();
		navigate("/reports/customerwithdrawals");
	};

	const openAgentWithdrawals = (e) => {
		e.preventDefault();
		navigate("/reports/agentwithdrawals");
	};

	return (
		<Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
			{/* cards */}
			<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
				Reports
			</Typography>
			<Grid container columns={12}>
				<Grid size={{ xs: 12, md: 12, lg: 12 }} sx={{ textAlign: "center" }}>
					<Button
						type="submit"
						size="large"
						startIcon={<AssessmentIcon />}
						variant="contained"
						onClick={openCustomerDeposits}
						sx={{ margin: 4 }}
					>
						Customer Deposits
					</Button>
					<Button
						type="submit"
						size="large"
						startIcon={<AssessmentIcon />}
						variant="contained"
						onClick={openCustomerWithdrawals}
						sx={{ margin: 4 }}
					>
						Customer Withdrawals
					</Button>
					<Button
						type="submit"
						size="large"
						startIcon={<AssessmentIcon />}
						variant="contained"
						onClick={openAgentWithdrawals}
						sx={{ margin: 4 }}
					>
						Agent Withdrawals
					</Button>
				</Grid>
			</Grid>
			<Copyright sx={{ my: 4 }} />
		</Box>
	);
};

export default ReportsMain;
